import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_487: DocMigration = {
  maxSchemaVersion: "0.0.487",
  description: "Rename columnOffset to columnLateralOffset and add headerLateralOffset to PorchSettings",
  apply(json: any): any {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type !== "PORCH_SETTINGS" && setting.type !== "REAR_PORCH_SETTINGS") {
        continue;
      }
      if (setting.columnOffset === undefined) {
        continue;
      }
      setting.columnLateralOffset = setting.columnOffset;
      setting.headerLateralOffset = setting.columnOffset;
      delete setting.columnOffset;
    }
    return json;
  },
};

export default migration_0_0_487;
